import React from "react";
import styled from "styled-components";
import LegalLinks from "./LegalLinks";

const SiteFooter = () => (
  <Wrap>
    <LegalLinks />
  </Wrap>
);

export default SiteFooter;

const Wrap = styled.div`
  width: 100%;
  max-width: var(--content-max);
  margin: 36px auto 4px;
  padding: 8px 18px 12px;

  @media (min-width: 1024px) {
    padding: 8px 32px 0;
    margin-top: 56px;
  }
`;
